<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" id="Capa_1" x="0px" y="0px" style="enable-background:new 0 0 39.5 39.5;" xml:space="preserve" viewBox="0 0 20 39.5">
<line style="fill:none;stroke:#7c7c7c;stroke-width:3;stroke-linecap:round;stroke-miterlimit:10;" x1="10" y1="20" x2="10" y2="38"/>
<circle style="fill:#DD352E;" cx="10" cy="10" r="10"/>
<circle style="fill:#F76363;" cx="6" cy="7" r="2"/>
</svg>